<template>
  <MetricCard
    apiEndpoint="/facebook/cost-per-click"
    metricName="CPC"
    :formatData="formatData"
    srcName="Facebook Ads"
  />
</template>

<script setup>
import MetricCard from '@/components/MetricCard.vue';
const formatData = (data) => '₹' + data.data;
</script>
